// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  StatsTable,
  ScoreCard,
  StatsGraph,
  EarningGraph,
  Notifications,
  WorkProgress,
  TwitterFeed,
  TodoListDemo,
  TeamMatesDemo,
  AllGametypeTab
}                         from '../../components';
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../components';
import StatsWidget from '../../components/statsWidget/StatsWidget.js';
import StatsWidget2 from '../../components/statsWidget/StatsWidget2.js';

class Home extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
      fetchEarningGraphDataIfNeeded:  PropTypes.func,
      fetchTeamMatesDataIfNeeded:     PropTypes.func,
      fetchStatsWidgetDataIfNeeded:     PropTypes.func,
      fetchStatsWidget2DataIfNeeded:     PropTypes.func,
      fetchStatsCardDataIfNeeded:       PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      rental_revenue_per_day_graph_tabs: [ 
          {name: 'Data', tablink: '1', isActive: true}, 
          {name: 'Daily Court Usage', tablink: '2', isActive: false},
          
      ],
      rental_revenue_per_day: [ 
          {name: 'Data', tablink: '3', isActive: true}, 
          {name: 'Daily Rental', tablink: '4', isActive: false},
          
      ],
            customers_trend: [
          {name: 'Data', tablink: '5', isActive: true}, 
          {name: 'Customer Trend', tablink: '6', isActive: false},
      ],
      revenue_trend: [
          {name: 'Data', tablink: '7', isActive: true}, 
          {name: 'Revenue Trend', tablink: '8', isActive: false},
      ]

    }
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    const {
      actions: {
        fetchEarningGraphDataIfNeeded,
        fetchTeamMatesDataIfNeeded,
        fetchStatsWidgetDataIfNeeded,
        fetchStatsWidget2DataIfNeeded,
        fetchStatsCardDataIfNeeded,
        fetchStatsTableDataIfNeeded
      }
    } = this.props;

    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  render() {
    const {
      teamMates,
      teamMatesIsFetching,
      earningGraphLabels,
      earningGraphDatasets,
      statsWidget,
      statsWidget2,
      statsCard,
      statsGraph,
      scoreCard,
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(
      <AnimatedView>
        <div className="row"><div className="col-md-12">
          <ScoreCard name="dashboard_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div></div>

        <div className="row">
        <div className="col-md-6 collection-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.rental_revenue_per_day_graph_tabs}/>
            <TabPanelBody>
              <TabPanelBodyContent id="1">
                <StatsTable name="court_usage_daily_data" data={statsTable} displayName="Daily Court Usage" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="2">
                <StatsGraph type="line" name="court_usage_daily" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>  
        <div className="col-md-6 daily-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.rental_revenue_per_day}/>
            <TabPanelBody>
              <TabPanelBodyContent id="3">
                <StatsTable name="daily_rental" data={statsTable} displayName="Daily Rental" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="4">
                <StatsGraph type="line" name="daily_rental_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>
        </div>
        <div className="row" style={{marginBottom:'2%'}}>
          <AllGametypeTab bigTable={true} displayName="Session Health" name="session_health" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="partner_demo_scheduled" displayName="Demo Scheduled" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>  
                <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="new_football_votein" displayName="Football Vote-in" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>   
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="new_badminton_votein" displayName="Badminton Vote-in" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>  
        <div className="row">
        <div className="col-md-6 ">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.customers_trend}/>
            <TabPanelBody>
              <TabPanelBodyContent id="5">
                <StatsTable name="active_customers_per_month_graph" data={statsTable} displayName="Customer Trend" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="6">
                <StatsGraph type="line" name="active_customers_per_month_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>  
        <div className="col-md-6 daily-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.revenue_trend}/>
            <TabPanelBody>
              <TabPanelBodyContent id="7">
                <StatsTable name="revenue_per_month_by_program_graph" data={statsTable} displayName="Revenue Trend" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="8">
                <StatsGraph type="line" name="revenue_per_month_by_program_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>
        </div>  
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="new_active_customers" displayName="Active Customer" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div> 
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="active_custombers_by_venue_by_program" displayName="Active Customer This Month" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="active_customers_today" displayName="Active Customer Today" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>     
             
     
        {/*



            <StatsWidget
              headers={statsWidget.headers}
              data={statsWidget.data}/>
            <StatsWidget
              headers={statsWidget2.headers}
              data={statsWidget2.data}/>
        <div className="row">
          <div className="col-md-6">
            <Notifications />
          </div>
          <div className="col-md-6">
            <WorkProgress />
          </div>
        </div>

        <div className="row">
        */}


          {/*
          <div className="col-md-7">
            <TodoListDemo />
          </div>
          */}


      </AnimatedView>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/views/home/Home.js